export default __webpack_public_path__ + "static/media/doug-full-1.66aa8c63.jpg";